<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <button @click="$emit('close')" class="close-modal">&times;</button>
      <h3>{{ plan.id ? "Edit Plan" : "Add New Plan" }}</h3>

      <form
        @submit.prevent="$emit('save', formData)"
        style="width: 100%; display: inline-block"
      >
        <div class="form-group">
          <label>Plan ID:</label>
          <input type="text" v-model="formData.planid" required />
        </div>

        <div class="form-group">
          <label>Network:</label>
          <select v-model="formData.network" required>
            <option value="1">MTN</option>
            <option value="2">Airtel</option>
            <option value="3">Glo</option>
            <option value="4">9mobile</option>
          </select>
        </div>

        <div class="form-group">
          <label>Name:</label>
          <input type="text" v-model="formData.name" required />
        </div>

        <div class="form-group">
          <label>Price:</label>
          <input type="number" v-model="formData.price" required />
        </div>

        <div class="form-actions">
          <button type="button" @click="$emit('close')" class="cancel-btn">Cancel</button>
          <button type="submit" class="submit-btn">
            {{ isLoading ? "Updating..." : plan.id ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    isLoading: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        planid: this.plan?.plan || "",
        network: this.plan?.network || "1",
        name: this.plan?.planname || "",
        price: this.plan?.price || 0,
        id: this.plan?.id || null,
      },
    };
  },

  watch: {
    plan: {
      immediate: true,
      handler(newVal) {
        this.formData = {
          planid: newVal?.plan || "",
          network: newVal?.network || "1",
          name: newVal?.planname || "",
          price: newVal?.price || 0,
          id: newVal?.id || null,
        };
      },
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.close-modal {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 16px;
  overflow: hidden;

  box-sizing: border-box;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  background: #f0f0f0;
  color: #666;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.submit-btn {
  background: #21b55a;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}
</style>
